import React from 'react'
import { DataBox } from './DataBox'
import { baseRoutineModel } from '../routineModel'
import { PageHeader } from './PageHeader'
import { AddRoutineModal } from './addRoutineModal'
import { EditRoutineModal } from './editRoutineModal'

export function BaseRoutine() {
    const { addCarVisible, editCarVisible } = baseRoutineModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddRoutineModal />}
            {editCarVisible && <EditRoutineModal />}
        </>
    )
}
